/* eslint-disable no-underscore-dangle */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { trackRenderedMbox } from "../../globalScriptProviders/satellite";
import logger from "../../logger";
import { handleCookies } from "../../utils/cookies";
import { handleScript } from "../../utils/scripts";
import { handleStorage } from "../../utils/storage";
// its dom less
var handleGlobalMbox = /*#__PURE__*/ _async_to_generator(function(mbox) {
    var _options, options, sideEffects, _options_, _options__content, content, tmp, _ref, experience, cookies, storage, evar, tmp1, value, script;
    return _ts_generator(this, function(_state) {
        options = mbox.options;
        sideEffects = [];
        if (((_options = options) == null ? void 0 : _options.length) > 0) {
            _options_ = options[0], _options__content = _options_.content, content = _options__content === void 0 ? {} : _options__content, tmp = _options_.responseTokens, _ref = tmp === void 0 ? {} : tmp, experience = _ref["experience.name"];
            cookies = content.cookies, storage = content.storage, evar = content.evar, tmp1 = content.evarValue, value = tmp1 === void 0 ? experience : tmp1, script = content.script;
            if (cookies) {
                handleCookies(cookies);
            }
            if (storage) {
                handleStorage(storage);
            }
            if (evar) {
                sideEffects.push(trackRenderedMbox({
                    evar: evar,
                    value: value
                }));
            }
            if (script) {
                sideEffects.push(handleScript(script).catch(function(error) {
                    logger.error("Remote script " + script.remote + "(" + script.component + ") execution", error);
                }));
            }
        }
        // Track side effects to allow consumers (tests) to await
        return [
            2,
            Promise.all(sideEffects)
        ];
    });
});
export { handleGlobalMbox };

//# sourceMappingURL=GlobalMbox.js.map